import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Skeleton,
  useTheme,
  useMediaQuery
} from '@mui/material';
import {
  People,
  PendingActions,
  Schedule,
  Search
} from '@mui/icons-material';

const StatsCards = ({ stats, loading }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const statItems = [
    {
      title: 'Approved Bookkeepers',
      value: stats.totalBookkeepers,
      icon: <People fontSize={isMobile ? "medium" : "large"} />,
      color: '#2196f3',
      description: 'Registered bookkeepers'
    },
    {
      title: 'Pending Approvals',
      value: stats.pendingApprovals,
      icon: <PendingActions fontSize={isMobile ? "medium" : "large"} />,
      color: '#ff9800',
      description: 'Awaiting approval'
    },
    {
      title: 'Expiring Soon',
      value: stats.expiringSoon,
      icon: <Schedule fontSize={isMobile ? "medium" : "large"} />,
      color: '#f44336',
      description: 'Listings expiring soon'
    },
    {
      title: 'Total Searches',
      value: stats.totalSearches,
      icon: <Search fontSize={isMobile ? "medium" : "large"} />,
      color: '#4caf50',
      description: 'Total search queries'
    }
  ];

  if (loading) {
    return (
      <Grid container spacing={2}>
        {statItems.map((_, index) => (
          <Grid item xs={6} md={3} key={index}>
            <Skeleton 
              variant="rectangular" 
              height={isMobile ? 80 : 120} 
              sx={{ borderRadius: 2 }}
            />
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Grid container spacing={2}>
      {statItems.map((stat, index) => (
        <Grid item xs={6} md={3} key={index}>
          <Card 
            sx={{ 
              height: '100%',
              transition: 'transform 0.2s, box-shadow 0.2s',
              border: '1px solid',
              borderColor: 'divider',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: 2
              }
            }}
          >
            <CardContent sx={{ p: isMobile ? 1.5 : 2, '&:last-child': { pb: isMobile ? 1.5 : 2 } }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Box 
                  sx={{ 
                    color: stat.color,
                    mr: 1.5,
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {stat.icon}
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography 
                    variant={isMobile ? "caption" : "body2"} 
                    component="div" 
                    color="text.secondary"
                    sx={{ 
                      fontWeight: 500,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}
                  >
                    {stat.title}
                  </Typography>
                  <Typography 
                    variant={isMobile ? "h6" : "h5"} 
                    component="div" 
                    sx={{ 
                      fontWeight: 'bold', 
                      mt: 0.5,
                      fontSize: isMobile ? '1rem' : '1.5rem'
                    }}
                  >
                    {stat.value}
                  </Typography>
                  <Typography 
                    variant="caption" 
                    color="text.secondary" 
                    sx={{ 
                      display: 'block',
                      mt: 0.5,
                      fontSize: isMobile ? '0.7rem' : '0.75rem'
                    }}
                  >
                    {stat.description}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default StatsCards;